import { create } from 'zustand';
import type { GeneratedNpc, Playbook } from '@bid/shared-types';
import { generateNpc } from '@bid/bitd-data';
import { saveContent } from '@bid/client-storage';

interface NPCStore {
  generatedNpc: GeneratedNpc | null;
  selectedPlaybook: Playbook | null;
  customName: string;
  isGenerating: boolean;
  generateNpc: () => void;
  setPlaybook: (playbook: Playbook | null) => void;
  setCustomName: (name: string) => void;
  saveNpc: () => Promise<number | null>;
}

export const useNPCStore = create<NPCStore>((set, get) => ({
  generatedNpc: null,
  selectedPlaybook: null,
  customName: '',
  isGenerating: false,

  generateNpc: () => {
    set({ isGenerating: true });
    const { selectedPlaybook, customName } = get();

    const npc = generateNpc({
      playbook: selectedPlaybook || undefined,
      name: customName || undefined,
    });

    set({
      generatedNpc: npc,
      isGenerating: false,
    });
  },

  setPlaybook: playbook => {
    set({ selectedPlaybook: playbook });
  },

  setCustomName: name => {
    set({ customName: name });
  },

  saveNpc: async () => {
    const { generatedNpc } = get();
    if (generatedNpc) {
      try {
        const id = await saveContent('npc', generatedNpc.name, generatedNpc);
        console.log('NPC saved with ID:', id);
        return id;
      } catch (error) {
        console.error('Error saving NPC:', error);
        return null;
      }
    }
    return null;
  },
}));
